import { measureListAnimationRow } from "./measureListAnimationRow";

export function storeInitialAndFinalRowPositionsLegacy(rows: Element[], animationRowIds: Set<string>, prevChildrenPositions: Map<string, DOMRect>, newChildrenPositions: Map<string, DOMRect>, rowItemParts: Map<string, Element[]>, isRemovalAction: boolean): void {
    let netHeightChange = 0;
    for (const row of rows) {
        const position = measureListAnimationRow(row, "storeInitialAndFinalRowPositions_rowBoundingClientRect");
        prevChildrenPositions.set(row.id, measureListAnimationRow(row, "storeInitialAndFinalRowPositions_prevChildrenPositions"));
        const newYCoordinate = measureListAnimationRow(row, "storeInitialAndFinalRowPositions_newYCoordinate").y +
            netHeightChange;
        newChildrenPositions.set(row.id, new DOMRect(position.x, newYCoordinate, position.width, position.height));
        
        if (animationRowIds.has(row.id)) {
            if (isRemovalAction) {
                netHeightChange -= measureListAnimationRow(row, "storeInitialAndFinalRowPositions_netHeightChange_substract").height;
            }
            else {
                (row as HTMLDivElement).style.display = "block";
                try {
                    netHeightChange += measureListAnimationRow(row, "storeInitialAndFinalRowPositions_netHeightChange_add").height;
                }
                finally {
                    (row as HTMLDivElement).style.display = "unset";
                }
            }
        }
        
        const itemPartWrapper = document.getElementById(`${row.id}_itemPartWrapper`);
        const itemParts = Array.from(itemPartWrapper?.children ?? []);
        if (itemParts.length > 0) {
            if (netHeightChange !== 0) {
                const expansionContainer = document.getElementById(`${row.id}_expansionAnimationWrapper`);
                if (expansionContainer) {
                    const expansionPosition = measureListAnimationRow(expansionContainer, "storeInitialAndFinalRowPositions_expansionContainerDomRect");
                    prevChildrenPositions.set(expansionContainer.id, expansionPosition);
                    newChildrenPositions.set(expansionContainer.id, new DOMRect(expansionPosition.x, expansionPosition.y + netHeightChange, expansionPosition.width, expansionPosition.height));
                    if (animationRowIds.has(row.id) && isRemovalAction) {
                        netHeightChange -= expansionPosition.height;
                    }
                    rowItemParts.set(row.id, [expansionContainer]);
                }
            }
            else {
                let itemPartNetHeightChange = 0;
                for (const itemPartRow of itemParts) {
                    const itemPartPosition = measureListAnimationRow(itemPartRow, "storeInitialAndFinalRowPositions_itemPartDomRect");
                    prevChildrenPositions.set(itemPartRow.id, itemPartPosition);
                    newChildrenPositions.set(itemPartRow.id, new DOMRect(itemPartPosition.x, itemPartPosition.y + itemPartNetHeightChange, itemPartPosition.width, itemPartPosition.height));
                    if (animationRowIds.has(itemPartRow.id)) {
                        if (isRemovalAction) {
                            itemPartNetHeightChange -= itemPartPosition.height;
                            netHeightChange -= itemPartPosition.height;
                            if (itemParts.length === 1) {
                                netHeightChange -= position.height;
                            }
                        }
                        else {
                            (itemPartRow as HTMLDivElement).style.display = "block";
                            itemPartNetHeightChange += itemPartPosition.height;
                            netHeightChange += itemPartPosition.height;
                            (itemPartRow as HTMLDivElement).style.display = "unset";
                        }
                    }
                }
                rowItemParts.set(row.id, itemParts);
            }
        }
    }
}
